export const aStockBuyMap: any = {
  today_order: {
    showBondSelect: true,
    showCheckUnveil: false,
    showBuyEntry: true,
    preCheck: true,
  },
  today_success: {
    showBondSelect: false,
    showCheckUnveil: true,
    showBuyEntry: false,
    preCheck: false,
  },
  wait_order: {
    showBondSelect: false,
    showCheckUnveil: false,
    showBuyEntry: false,
    preCheck: true,
  }
}

export const noDataConfigList: any = {
  todayBuy: {
    name: '今日新股(0)/新债(0)',
    nameStock: '今日新股(0)',
    text: '今日暂无新股',
    showBondSelect: true,
    hasNoRadius: true,
  },
  todaySucces: {
    name: '今日中签公布',
    nameStock: '今日中签公布',
    text: '今日暂无中签公布',
    showBondSelect: false,
    hasNoRadius: false,
  },
  willBuy: {
    name: '',
    nameStock: '',
    text: '暂无申购内容',
    showBondSelect: false,
    hasNoRadius: false,
  }
}